import Svg, { type SvgProps } from '../../Svg';

/**
 * OpenLink Icon from Figma
 * @link [Figma](https://www.figma.com/file/bUeKiC8YcV9PHrMlJAZUJG/Design-System?node-id=1010%3A23781&mode=dev)
 * */
const OpenLinkIcon = (props: SvgProps) => (
  <Svg width={12} height={12} {...props}>
    <path
      className="stroke-current"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M11 2.5H7C6.57565 2.5 6.16869 2.64048 5.86863 2.89052C5.56857 3.14057 5.4 3.47971 5.4 3.83333V5.5M9.5 4.5L11.5 2.5L9.5 0.5M9.25 7V10.75C9.25 10.9489 9.17098 11.1397 9.03033 11.2803C8.88968 11.421 8.69891 11.5 8.5 11.5H1.75C1.55109 11.5 1.36032 11.421 1.21967 11.2803C1.07902 11.1397 1 10.9489 1 10.75V4.75C1 4.55109 1.07902 4.36032 1.21967 4.21967C1.36032 4.07902 1.55109 4 1.75 4H3"
    />
  </Svg>
);

export default OpenLinkIcon;
